import React, { useState } from "react"
import PropTypes from "prop-types"
import { CardActions, IconButton, Menu, MenuItem } from "@mui/material"
import MoreVertIcon from "@mui/icons-material/MoreVert"

const TemplateCardActions = ({ actions = [] }) => {
  const [anchorEl, setAnchorEl] = useState(null)

  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleAction = callback => {
    handleClose()
    callback?.()
  }

  return (
    <CardActions>
      <IconButton onClick={handleClick} disabled={actions.length === 0}>
        <MoreVertIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        {actions.map(action => (
          <MenuItem
            key={action.key}
            onClick={() => handleAction(action.onClick)}
          >
            {action.label}
          </MenuItem>
        ))}
      </Menu>
    </CardActions>
  )
}

TemplateCardActions.propTypes = {
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      onClick: PropTypes.func,
    }),
  ),
}

export default TemplateCardActions
